<template>
  <div class="header-fluid">
    <div class="header FontSize14 between">
      <div class="flex_start">
        <div class="address center text_hover_shou">
          <div><img src="~assets/base/zuobiao.png"  /></div>
          <div class="text">{{cityname}}</div>
          <div class="flip90">
            <svg-icon icon-class="jt_right"></svg-icon>
          </div>

          <div class="address_info">
            <div class="city">
              <div class="hot_city_title">热门城市</div>
              <div class="city_name flex_start wrap">
                <span v-for="(item, index) in hotcitys" :key="index" class="name_item"
				@click="clickcity(item.name)"
                  >{{item.name}}</span
                >
                <!-- <span class="name_item all">全部</span> -->
              </div>
            </div>
            <div class="city">
              <div class="hot_city_title">按首字母选择</div>
              <div class="city_initial around">
                <span
                  v-for="(item, index) in citylist"
                  :key="index"
                  @click="selectinitial(index)"
                >
                  {{index}}
                </span>
              </div>
              <div class="city_name flex_start wrap">
                <span v-for="(item, index) in citylist[theindex]" :key="index" class="name_item"
				@click="clickcity(item.name)"
                  >{{item.name}}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="enter_address header_text_color">进入合肥站</div>
      </div>
      <div class="flex_end">
        <div class="login header_text_color" @click="tologin">登录</div>
        <div class="regin header_text_color" @click="tologsin">免费注册</div>
        <div class="web_address center text_hover_shou">
          <div class="web_address_text">网站导航</div>
          <div class="flip90">
            <svg-icon icon-class="jt_right" ></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
	
export default {
  name: "lvHeader",
  data() {
    return {
		citylist:[],
		theindex:'A',
		cityname:'',
		hotcitys:[]
	};
  },
  created() {
	  this.getLocation()
  	this.$http.home.areas().then(res => {
		this.citylist = res.data
	})
	this.$http.home.hotcitys().then(res => {
		this.hotcitys = res.data
	})
  },
  mounted() {},
  methods: {
    selectinitial(index) {
	  this.theindex = index
    },
    tologin(){
      this.$router.push('/log/login')
    },
    tologsin(){
      this.$router.push('/log/logsig')
    },
	clickcity(name){
		this.cityname = name
	},
	getLocation() {
	        const self = this
	        AMap.plugin('AMap.Geolocation', function () {
	            var geolocation = new AMap.Geolocation({
	                // 是否使用高精度定位，默认：true
	                enableHighAccuracy: true,
	                // 设置定位超时时间，默认：无穷大
	                timeout: 10000,
	            })
	
	            geolocation.getCurrentPosition()
	            AMap.event.addListener(geolocation, 'complete', onComplete);
	            AMap.event.addListener(geolocation, 'error', onError);
	
	            function onComplete(data) {
	                // data是具体的定位信息
	                console.log('定位成功信息：', data.position);
					axios.get('https://restapi.amap.com/v3/geocode/regeo?output=JSON&location=' + data.position.lng + ',' + data.position.lat + '&key=e7485e5659f0132a37f9945d1e639bbc').then((response) => {
					  console.log(response.data)
					  self.cityname = response.data.regeocode.addressComponent.city
					})
	            }
	
	            function onError(data) {
	                // 定位出错
	                console.log('定位失败错误：', data);
	                // 调用ip定位
	                self.getLngLatLocation();
	            }
	        })
	    },
	    getLngLatLocation() {
	        AMap.plugin('AMap.CitySearch', function () {
	            var citySearch = new AMap.CitySearch();
	            citySearch.getLocalCity(function (status, result) {
	                if (status === 'complete' && result.info === 'OK') {
	                    // 查询成功，result即为当前所在城市信息
	                    console.log('通过ip获取当前城市：', result)
	                    //逆向地理编码
	                    AMap.plugin('AMap.Geocoder', function () {
	                        var geocoder = new AMap.Geocoder({
	                            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
	                            city: result.adcode
	                        })
	
	                        var lnglat = result.rectangle.split(';')[0].split(',');
	                        geocoder.getAddress(lnglat, function (status, data) {
	                            if (status === 'complete' && data.info === 'OK') {
	                                // result为对应的地理位置详细信息
	                                console.log(data)
	                            }
	                        })
	                    })
	                }
	            })
	        })
	    }
	
  },
};
</script>

<style lang="scss" scoped>
.header-fluid {
  background-color: #f8f8f8;
  width: 100%;
  height: 100%;
  .header {
    margin: 0 auto;
    width: 1200px;
    height: 38px;
    line-height: 38px;
    align-items: center;
    color: #999999;

    .header_text_color {
      color: #0465ea;
      &:hover {
        color: #fff;
        background-color: #0465ea;
      }
    }

    .address {
      position: relative;
      padding: 0 10px 0 0;

      img{
        vertical-align: -0.15em;
      }

      .text {
        margin: 0 4px 0 6px;
      }
      &:hover {
        .address_info {
          top: 38px;
          visibility: visible;
          opacity: 1;
          transition: all 0.5s;
        }
      }
      .address_info {
        position: absolute;
        z-index: 999;
        visibility: hidden;
        opacity: 0;
        width: 610px;
        min-height: 350px;
        padding: 18px 30px;
        top: 58px;
        left: 0;
        box-shadow: 0 4px 20px rgb(0 0 0 / 5%);
        background-color: #fff;
        .city {
          margin-bottom: 20px;
          .city_name {
            position: relative;
          }
          &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }

          .hot_city_title {
            color: #999;
            font-size: 16px;
          }
          .city_initial {
            font-size: 16px;
            color: #333;
            font-weight: 600;
            cursor: pointer;
            span:hover {
              color: #0057ff;
            }
          }
          .name_item {
            color: #333;
            line-height: 32px;
            min-width: 8%;
			margin-right: 10px;
            &:hover {
              color: #0057ff;
            }
          }

          .all {
            position: absolute;
            bottom: 0;
            right: -10px;
            color: #0057ff;
            &:hover {
              color: red;
            }
          }
        }
      }
    }
    .enter_address {
      height: 38px;
      padding: 0 10px;
      margin-left: 20px;
    }
    .login,
    .regin {
      padding: 0 10px;
      cursor: pointer;
    }
    .web_address {
      .web_address_text {
        margin: 0 6px 0 10px;
      }
    }
  }
}
</style>
